import { datadogRum } from '@datadog/browser-rum'

import { isRumEnabledForCompany } from 'modules/core/lib/datadogRumUtils'

interface DatadogTrackingData {
  userId: string
  accessId: string
  companyId: string
  companyName: string
  datadogEnvironment: string
  allowedCompanyIds: string[]
}

const runDatadog = ({
  userId,
  accessId,
  companyId,
  companyName,
  datadogEnvironment,
  allowedCompanyIds,
}: DatadogTrackingData) => {
  if (!isRumEnabledForCompany(datadogEnvironment, allowedCompanyIds, companyId)) {
    return
  }

  datadogRum.setUser({
    id: userId.toString(),
    accessId,
    companyId,
    companyName,
  })
}

export default runDatadog
